'use client';

import { OperatingMarginResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: OperatingMarginResult;
  translations: ToolsTranslations['operatingMargin'];
}

export default function ResultsDisplay({ result, translations }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.marginPercent !== null ? `${result.marginPercent.toFixed(2)}%` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>
    </div>
  );
}


